import React from 'react'
import Gallery from '../components/ScholarshipGallery'
import _ from 'underscore';
import styles from '../styles/university.module.css';
import { Grid, Icon, Input, Container, Segment, Header, Divider, Image, Table, Pagination, List } from 'semantic-ui-react'
import scholarshipsImage from './assets/scholarships.jpg'
import Helmet from 'react-helmet'
import { slash, arrayToURL, toSlug } from '../utils/utils'
import Link from "gatsby-link"

export default class Scholarships extends React.Component {


  state = { activePage: 1, searchKey: '' }

  handleInputChange = (e, { value }) => {
    this.setState({ searchKey: value });
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
  }

  handleInputRemove = (e) => {
    const { searchKey } = this.state;
    if(searchKey !== '') {
      this.setState({ searchKey: ''});
    }
  }


  render() {
    const { activePage, searchKey } = this.state
    const itemPerPage = 30;
    const scholarships = this.props.data.scholarships.group;
    const icon = searchKey !== '' ? 'remove' : 'search';
    const entries = scholarships.reduce((acc, {edges}) => {

       edges.forEach(({node}) => {
         const uslug = toSlug(node.university);
         const university = node.university;
         const headline = node.headline;
         const title = toSlug(node.title);
         const photo = node.photo;
         acc.push({ university, headline, title, uslug, photo });
       });
         return acc;
       }, []).filter(({university, title}) => {
          return university && title
       }).map(({uslug, headline, university, title, photo}, idx) => {
           const path = slash(arrayToURL([toSlug(university), toSlug(title)]));
           return {
             image: photo,
             title: headline,
             path: path,
             headline: headline,
             university: university
        }
     });
    const totalPages = Math.floor(entries.length / itemPerPage);
    const from = (activePage - 1) * itemPerPage;
    const to = activePage * itemPerPage;
    const data = entries
      .slice(from , to)
      .filter(({ headline, university }) => {
        const key = searchKey.toLowerCase();
        return headline.toLowerCase().indexOf(key) !== -1
          || university.toLowerCase().indexOf(key) !== -1
      });

    const pageTitle = "FIND SCHOLARSHIP NOW! | Uni Village Education";
    const description = "We provide more than 100 courses information. Find your right course right now!";

      return (
      <Container textAlign='center'>
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={description} />
        </Helmet>
        {entries.map(({path, university, title}) => {
          return <a style={{display:'none'}} href={path}>{title} in {university}</a>
        })}
        <Header as='h3' icon>
          SCHOLARSHIP APPLICATION
          <Header.Subheader>
              We help students find the best university based scholarships
              or external scholarships ranging from foundation studies,
              pre-university, diploma, and degree qualifications
              based on selection criteria such as academic excellence,
              co-curricular achievements or financial status.
          </Header.Subheader>
        </Header>
        <Image src={scholarshipsImage}  fluid />
        <Divider hidden />
        <Input size='small' icon={icon} value={searchKey} placeholder='Search university name'
          fluid onChange={this.handleInputChange}
          onClick={this.handleInputRemove} />
        { searchKey === '' && <Header size='small' textAlign='left'>{from +1 } of {entries.length} results</Header>}
        { searchKey !== '' && <Header size='small' textAlign='left'>{data.length} results</Header>}
        <Divider hidden />
        <Gallery data={data} />
        <Divider hidden />
        { searchKey === '' && <Pagination firstItem={null} lastItem={null} activePage={activePage}
          onPageChange={this.handlePaginationChange} totalPages={totalPages} />}
        <Divider hidden />
      </Container>
    )
  }
}

export const scholashipsQuery = graphql`
  query ScholarshipsQuery {
      scholarships: allScholarshipsJson {
        totalCount
        group(field: university) {
          edges {
            node {
              photo
              title
              university
              headline
            }
          }
        }
      }
  }
`



// WEBPACK FOOTER //
// ./src/pages/scholarships.js